module.exports = __webpack_public_path__ + "static/img/SFM-399-1.29a97b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/SFM-399-1.jpg
// module id = 3Ovw
// module chunks = 0